if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super()
        this.reinitalize = this.reinitalize.bind(this)
        this.stickyAddObserver = null
        this.atcMutationObserver = null
        this._mutationRaf = null
        this._intersectionObserved = null
        this._onStickyClick = (e) => {
          e.preventDefault()
          const main = this.resolveMainCta()
          if (main instanceof HTMLElement) {
            main.click()
            main.scrollIntoView({ behavior: 'smooth' })
          }
        }
      }
      connectedCallback() {
        setTimeout(() => {
          this.init()
        })

        document.addEventListener('product:reload', this.reinitalize)
      }

      disconnectedCallback() {
        document.removeEventListener('product:reload', this.reinitalize)
        this.atcMutationObserver?.disconnect()
        this.stickyAddObserver?.disconnect()
        this.button?.removeEventListener('click', this._onStickyClick)
        this._intersectionObserved = null
      }

      /**
       * Matches the visible primary CTA in the section (add vs notify-me).
       */
      resolveMainCta() {
        const section = this.closest('.shopify-section')
        if (!section) return null
        const addBtn = section.querySelector('button[name="add"]')
        const notifyBtn = section.querySelector('button.btn-notifyme')
        if (addBtn && !addBtn.classList.contains('hidden')) return addBtn
        if (notifyBtn && !notifyBtn.classList.contains('hidden'))
          return notifyBtn
        return addBtn || notifyBtn
      }

      setupButton() {
        this.button = this.querySelector('button')
        if (!this.button) return
        if (!this._clickBound) {
          this.button.addEventListener('click', this._onStickyClick)
          this._clickBound = true
        }
      }

      applyMainCtaToSticky() {
        this.button = this.button || this.querySelector('button')
        if (!this.button) return

        this.mainCTA = this.resolveMainCta()
        if (!this.mainCTA) return

        const mainSpan = this.mainCTA.querySelector('span')
        const stickySpan = this.button.querySelector('span')
        if (mainSpan && stickySpan) {
          stickySpan.textContent = mainSpan.textContent
        }

        if (this.mainCTA.hasAttribute('disabled')) {
          this.button.setAttribute('disabled', 'disabled')
        } else {
          this.button.removeAttribute('disabled')
        }

        this.setupIntersection()
      }

      init() {
        this.setupButton()
        this.applyMainCtaToSticky()
        this.mutation()
      }
      reinitalize() {
        this.atcMutationObserver?.disconnect()
        this.stickyAddObserver?.disconnect()
        this._intersectionObserved = null
        setTimeout(() => {
          this.init()
        }, 500)
      }
      setupIntersection() {
        const target = this.mainCTA || this.resolveMainCta()
        if (!target) return
        if (this._intersectionObserved === target) return
        this.stickyAddObserver?.disconnect()
        this._intersectionObserved = target

        const stickyAddOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0.5,
        }
        const stickyAddCallback = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.setAttribute('data-show', 'false')
            } else {
              this.setAttribute('data-show', 'true')
            }
          })
        }

        this.stickyAddObserver = new IntersectionObserver(
          stickyAddCallback,
          stickyAddOptions
        )

        this.stickyAddObserver.observe(target)
      }
      mutation() {
        const section = this.closest('.shopify-section')
        if (!section) return
        const form =
          section.querySelector('product-form') ||
          section.querySelector('.bundle-product-form') ||
          section
        if (!form) return

        this.atcMutationObserver?.disconnect()

        const scheduleSync = () => {
          if (this._mutationRaf != null) return
          this._mutationRaf = requestAnimationFrame(() => {
            this._mutationRaf = null
            this.applyMainCtaToSticky()
          })
        }

        this.atcMutationObserver = new MutationObserver(scheduleSync)
        this.atcMutationObserver.observe(form, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        })
      }
    }
  )
}
